import { InjectionToken } from '@angular/core';
import { AppStorage } from '../interfaces/app-storage.interface';

export const APP_STORAGE = new InjectionToken<AppStorage>('App storage service');
